import type { ShortcutJs } from "@/generated/models";
import { defineStore } from "pinia";
import { computed, ref, shallowRef } from "vue";

type RuntimeLoadingState = "idle" | "starting" | "error" | "ready";
type DocumentLoadingState = "idle" | "starting" | "loading" | "ready";

export const useDocumentStore = defineStore("document", () => {
  const runtimeState = ref<RuntimeLoadingState>("idle");
  const runtimeLoadingError = ref<Error>();

  const loadingState = ref<DocumentLoadingState>("idle");
  const objectId = ref<string>();
  const documentNodeId = ref<string>();
  const viewportBoundary = shallowRef<HTMLElement>();
  const specContainer = shallowRef<HTMLElement>();
  const moving = ref(false);
  const maintenanceMode = ref(false);
  const maintenanceMessage = ref<string>();
  const clientUpdateRequested = ref(false);
  const addToLibraryRequested = ref(false);
  const playerIsOpen = ref(false);
  const isPrinting = ref(false);

  const file = shallowRef<ShortcutJs>();
  const shortcut = computed(() => file.value?.Shortcut);
  function setFile(newFile: ShortcutJs) {
    file.value = newFile;
  }

  return {
    file,
    shortcut,
    setFile,
    state: loadingState,
    runtimeState,
    runtimeLoadingError,
    objectId,
    documentNodeId,
    viewportBoundary,
    specContainer,
    moving,
    maintenanceMode,
    maintenanceMessage,
    clientUpdateRequested,
    addToLibraryRequested,
    playerIsOpen,
    isPrinting,
  };
});
